import FilterContainer from './filter-container';
import { getCurrencyText } from '@/core/helpers/display';

export default {
    components: {
        FilterContainer,
    },
    props: {
        values: { // Front-end query filter values
            type: Array,
            required: true,
        },
        filters: { // Backend response allowed filters list
            type: Array,
            required: true,
        },
        totalItemsCount: {
            type: Number,
            required: true,
        },
        hasResults: {
            type: Boolean,
            required: true,
        },
        hasSelected: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            localValues: null,
        };
    },
    computed: {
        computedValues() {
            return this.localValues ? this.localValues.filters : this.values;
        },
    },
    methods: {
        handleResetFilters() {
            this.$emit('close');
            this.$emit('reset');
        },
        resolveValue(filter) {
            return this.computedValues.find(query => query.field === filter.name) || '';
        },
        onFilterChange({ field, ...params }) {
            const allowedFilters = this.filters.map(filter => filter.name);
            const hasParams = !!Object.keys(params).length;
            const output = this.values
                .filter(filter => filter.field !== field && allowedFilters.includes(filter.field))
                .slice(0);
            if (allowedFilters.includes(field) && hasParams) {
                output.push({ field, ...params });
            }

            this.$emit('change', { filters: output, changed: [field] });
        },
        getSymbol(filterType) {
            const currency = getCurrencyText(this.currency);
            return filterType === 'price' ? this.$configuration.offer.currency || currency : '';
        },
        handleSearch() {
            this.$emit('change', this.localValues);
            this.$emit('close');
        },
    },
};
